import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

// Единое пустое состояние для таблиц/списков — заменяет разнобой в текущем
// оформлении пустых состояний по разным страницам.
const EmptyState = ({ icon, title = 'Ничего не найдено', description, action }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={1.5}
    sx={{ py: 6, px: 2, textAlign: 'center' }}
  >
    <Box sx={{ fontSize: 40, display: 'flex', color: 'text.secondary', opacity: 0.6 }}>
      {icon || <InboxOutlinedIcon fontSize="inherit" />}
    </Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 1 }}>{action}</Box>}
  </Stack>
);

export default EmptyState;
